<template lang="pug">
  section#instacart-map.map
    .map-descriptions(ref="mapContent")
      .map-descriptions__wrapper
        button(@click="hideDescription")
          svg(width="13", height="13", viewBox="0 0 13 13", fill="none", xmlns="http://www.w3.org/2000/svg")
            path(d="M12.0209 12.0208L0.7072 0.707107", stroke-linecap="round")
            path(d="M12.0208 0.707107L0.707119 12.0208", stroke-linecap="round")
        .map-descriptions__image
          img(:src="shopperImage", v-show="isLoad", @load="loaded", alt="Instacart shopper" width="300" height="300")
        .map-descriptions__text
          .map-descriptions__inner
            h3 Applauding
            h4#shopperTitle
              | {{ shopperTitle }} 
              #lottie-description.lottie-anim
              //img(src="@/assets/images/clapping-crop.gif" alt="Clapping animation")
            p#shopperLocation.map-descriptions__paragraphs.font-bold {{ shopperLocation }}
            p#shopperCount.map-descriptions__paragraphs.font-bold {{ shopperCount }}
            p#shopperDescription.map-descriptions__paragraphs(v-html="shopperDescription")
            p#shopperCart.map-descriptions__paragraphs.font-bold
              | Items always in
              | {{ shopperTitle | lowecase }} 
              | cart? 
              span {{ shopperCart }}
            p#shopperDeliveries.map-descriptions__paragraphs.font-bold
              | Total Deliveries: 
              span {{ shopperDeliveries }}
    .map-descriptions__backdrop(v-if="descriptionOpen", @click="hideDescription")
      #lottie-backdrop.lottie-anim
      //img(src="@/assets/images/clapping.gif", alt="Clapping loading", v-if="loading")
    
    .map-views
      #galleryControl.map-views__item(@click="galleryView($event)" :class="{ 'active' : showingGallery }") Gallery
      #mapControl.map-views__item(@click="mapView($event)" :class="{ 'active' : showingMap }") Map
      
    .map-text
      .map-text__center
        img(src="@/assets/images/beyond-image-carrot-white.png", alt="Instacart logo white" width="80" height="83")
        h2 Beyond the Cart:
        p A Year of Essential Stories
      //.map-text__right
        img(src="@/assets/images/powered-by-map.svg")
    .map-elements
      img.home-cloud__left(src="@/assets/images/cloud-left.png" alt="Clouds")
      img.home-cloud__top(src="@/assets/images/cloud-top.png" alt="Clouds")
      img.home-cloud__right(src="@/assets/images/cloud-right.png" alt="Clouds")
    SvgMap
    section#instacart-gallery.gallery(v-bind:class="showingGallery ? 'showing' : ''")
      Gallery(v-if="showingGallery")
    
    
      
      

</template>
<script>

import SvgMap from "./SvgMap.vue"
import Gallery from "./Gallery.vue"
import instacartMap from "../assets/instacartMap"
import { gsap } from 'gsap'
import lottie from 'lottie-web';
import lottieFile from "../assets/images/clapping.json";

export default {
  name: 'App',
  data: function () {
      return {
          shopperImage: null,
          shopperTitle: null,
          shopperLocation: null,
          shopperCount: null,
          shopperDescription: null,
          shopperCart: null,
          shopperDeliveries: null,
          descriptionOpen: null,
          loading: false,
          isLoad: false,
          lastImage: null,
          showingGallery: true,
          showingMap: false,
          lottieFile: lottieFile
      }
  },
  watch: { 
    descriptionOpen: function() { // watch it
      if(this.descriptionOpen){
        setTimeout(()=>{
          const animClapping1 = {
            container: document.getElementById('lottie-backdrop'),
            renderer: 'svg',
            loop: true,
            autoplay: true,
            path: 'clapping.json',
          }
          lottie.loadAnimation(animClapping1);
        }, 100)
      }  
    }
  },
  created(){
    this.$root.$refs.descriptions = this;
  },
  filters: {
  lowecase: function (value) {
    if (!value) return ''
    value = value.split(' ')[0].toString()  
    if(value.slice(-1) == 'S'){
      value = value + "'";
    }else{
      value = value + "’s";
    }
    return value.charAt(0).toUpperCase() + value.slice(1).toLowerCase()
  }
},
  components: {
    SvgMap,
    Gallery
  },
  mounted: function () {
    this.loadLottie();
  },
  methods: {
    loadLottie(){
      const animClapping = {
        container: document.querySelector('.lottie-anim'),
        renderer: 'svg',
        loop: true,
        autoplay: true,
        path: 'clapping.json',
      }
      lottie.loadAnimation(animClapping)
    },
    enterMenu(){
      document.body.classList.add('menu-open');
      const tl = gsap.timeline()
      tl.to('.map-menu', 0.5, {x:0, ease: "power1.out"});
    },
    outMenu(){
      document.body.classList.remove('menu-open');
      const tl = gsap.timeline()
      tl.to('.map-menu', 0.5, {x:-400, ease: "power1.out"});
    },
    mapView(){
      const vue = this;
      if(event.target.classList.contains('active')) return false;
      vue.showingLoading();
      vue.showingGallery = false;
      vue.showingMap = true;
      setTimeout(() =>{
        vue.hideLoading();
        gsap.to('.map-container', 1, {alpha:1});
      }, 1000)
      
    },
    galleryView(){
      const vue = this;
      console.log(event.target.classList.contains('active'));
      //if(event.target.classList.contains('active') || rute) return false;
      if(document.querySelector('#galleryControl').classList.contains('active')) return false;

      vue.showingLoading();
      vue.showingGallery = true;
      vue.showingMap = false;
      gsap.to('.map-container', 0, {alpha:0});
    },
    showingLoading(){
      const vue = this;
      vue.descriptionOpen = true;
      vue.loading = true;
    },
    hideLoading(){
      const vue = this;
      vue.descriptionOpen = false;
      vue.loading = false;
    },
    getDescription: function(id, path){
      const vue = this;
      let mapData = instacartMap.g.path;      
      mapData.forEach((pathObj) => {
        let id_json = pathObj["-id"];
        if(id == id_json){
          vue.descriptionOpen = true;
          path != 'gallery' ? vue.$root.$refs.svgMap.hidePath() : '';     
          vue.shopperImage = pathObj["-image"];
          vue.shopperTitle = pathObj["-title"];
          vue.shopperDescription = pathObj["-description"];
          vue.shopperLocation = pathObj["-location"];
          vue.shopperCount = pathObj["-shopper"];
          vue.shopperCart = pathObj["-cart"];
          vue.shopperDeliveries = pathObj["-deliveries"];
          this.loading = true;
          
          if(vue.lastImage == vue.shopperImage){
            this.loaded();
          }
          vue.lastImage = vue.shopperImage;
      
        }
      })
    },
    loaded() {
      this.isLoad = true;      
      setTimeout(() => {
        this.loading = false;
        this.showDescription();
      },1000);
    },
    showDescription(){
      const vue = this;
      gsap.to(vue.$refs.mapContent, 0, {autoAlpha: 0, display:'block'},"0");
      gsap.to(vue.$refs.mapContent, 0.5, {autoAlpha: 1, display:'block'},"0.3");
      this.loadImageDescription = false;
    },
    hideDescription(){
      document.querySelector('#instacart-pines g path').style.display = 'block';
      gsap.to(this.$refs.mapContent,0.5, {autoAlpha: 0},"0");
      gsap.to(this.$refs.mapContent, 0, {display:'block'},"0.3");
      this.descriptionOpen = false;
      this.$root.$refs.svgMap.showPath();
    },
  }
}
</script>
<style lang="scss">
body{
  &.menu-open{
    overflow: hidden;
  }
}
.map{
  position: relative;
  display: block;
  background-color: $soft_brown;
  width: 100vw;
  height: 100vh;
  overflow: hidden;
  &::before{
    content: '';
    position: absolute;
    width: 100%;
    height: 50%;
    top: 0;
    left: 0;
    pointer-events: none;
    /* Permalink - use to edit and share this gradient: https://colorzilla.com/gradient-editor/#cec9c0+40,fcfaf6+100&1+61,0+100 */
    background: -moz-linear-gradient(top,  rgba(206,201,192,1) 40%, rgba(222,218,211,1) 61%, rgba(252,250,246,0) 100%); /* FF3.6-15 */
    background: -webkit-linear-gradient(top,  rgba(206,201,192,1) 40%,rgba(222,218,211,1) 61%,rgba(252,250,246,0) 100%); /* Chrome10-25,Safari5.1-6 */
    background: linear-gradient(to bottom,  rgba(206,201,192,1) 40%,rgba(222,218,211,1) 61%,rgba(252,250,246,0) 100%); /* W3C, IE10+, FF16+, Chrome26+, Opera12+, Safari7+ */
    filter: progid:DXImageTransform.Microsoft.gradient( startColorstr='#cec9c0', endColorstr='#00fcfaf6',GradientType=0 ); /* IE6-9 */
  }
  &-text{
    position: absolute;
    width: 100%;
    height: auto;
    top: 30px;
    left: 0;
    display: flex;
    justify-content: center;
    z-index: 3;
    padding: 0 1rem;
    pointer-events: none;
    @include respond-to('mobile'){
      padding: 0 2rem;
      top: 10px;
    }
    h2{
      color: $white;
      font-weight: 900;
      margin: 0;
      text-shadow: 0px 0px 20px #00150F;
      @include respond-to('small'){
        font-size: 2.5rem;
      }
    }
    p{
      text-align: center;
      color: $white;
      margin: 0;
      font-weight: 900;
      text-shadow: 0px 0px 20px #00150F;
    }
    &__right{
      position: absolute;
      right: 2rem;
    }
    &__center{
      position: relative;
      img{
        position: absolute;
        left: -25px;
        top: -15px;
        width: 60px;
        @include respond-to('mobile'){
          left: -50px;
          top: -15px;
          width: 80px;
        }
      }
    }
  }
  &-nav{
    position: absolute;
    width: 46px;
    height: 46px;
    top: 20px;
    left: 20px;
    background: $green;
    border-radius: 50%;
    display: flex;
    justify-content: center;
    align-items: center;
    cursor: pointer;
    z-index: 5;
  }
  &-zoom{
    position: absolute;
    width: 40px;
    border: 1px solid $soft_green;
    border-radius: 10px;
    right: 20px;
    bottom: 40px;
    z-index: 2;
    background: rgba(11, 96, 72, 0.5);
    &__item{
      text-align: center;
      color: $white;
      font-size: 1.5rem;
      border-bottom: 1px solid $soft_green;
      cursor: pointer;
      &:last-child{
        border-bottom: none;
      }
    }
  }
  &-menu{
    position: fixed;
    top: 0;
    transform: translate(-400px);
    height: 100%;
     background-color:$soft_green;
     padding: 1rem 3rem;
      border-radius: 0;
      width: 100%;
     z-index: 9;
     display: flex;
     justify-content: center;
     align-items: center;
     flex-flow: column;
     @include respond-to('mobile'){
       border-radius: 0 40px 40px 0;
       width: auto;
     }
     &__close{
       margin: 0 auto;
       display: block;
       border: none;
       background: transparent;
       text-align: center;
       color: $white;
       font-size: 0.8rem;
       position: absolute;
       top: 1rem;
       @include respond-to('mobile'){
         top: 2rem;
       }
       @include transition(all 0.5s ease 0s);
       svg{
         display: block;
         margin: 0 auto;
         width: 15px;
         stroke: $white;
         @include transition(all 0.5s ease 0s);
       }
       &:hover{
         color: $green;
         svg{
           stroke: $green;
           transform: rotate(720deg);
         }
       }
     }
     ul{
       margin: 0;
       padding: 0;
       display: flex;
      flex-flow: column;
      justify-content: center;
      align-items: center;
      list-style-type: none;
      li{
        margin: 0.5rem 0;
        @include respond-to('mobile'){
          margin: 1rem 0;
        }
        button{
          border: none;
          background: transparent;
          color: $white;
          font-weight: 900;
          font-size: 1.5rem;
          @include transition(all 0.5s ease 0s);
        }
        &:hover, &.active{
          button{
            color: $green;
          }
        }
        ul.menu-socials{
          flex-flow: row;
          li{
            margin: 0 0.5rem;
            a{
              background: $white;
              padding: 8px 10px;
              border-radius: 50%;
              @include transition(all 0.5s ease 0s);
              @include respond-to('mobile'){
                padding: 11px 10px;
              }
              &:hover{
                background: $green;
                svg{
                  fill: $white;
                }
              }
              svg{
                width: 18px;
                height: 18px;
                @include respond-to('mobile'){
                  width: 25px;
                  height: 25px;
                }
                fill: $soft_green;
                @include transition(all 0.5s ease 0s);
              }
            }
          }
        }
      }
     }
     .powered-by{
       position: absolute;
       bottom: 0rem;
       @include respond-to('mobile'){
         bottom: 1.5rem;
       }
     }
  }
  &-views{
    position: absolute;
    width: 150px;
    border: 1px solid #1FA737;
    border-radius: 10px;
    left: 50%;
    bottom: 40px;
    transform: translate(-50%, 0);
    z-index: 2;
    background: rgba(11, 96, 72, 0.5);
    display: flex;
    flex-wrap: wrap;
    overflow: hidden;
    z-index: 10;
    @include respond-to('small'){
      left: 20px;
      transform: translate(0,0);
    }
    &__item{
      text-align: center;
      color: #FFFFFF;
      font-size: 0.875rem;
      cursor: pointer;
      width: 50%;
      padding: 0.25rem 0;
      @include transition(all 0.5s ease 0s);
      @include respond-to('small'){
        padding: 0.5rem 0;
      }
      &.active{
        background-color: $soft_green;
      }
    }
  }
}
</style>
